import _ from 'lodash';
import React, { useState } from 'react';
import { BookingViewTabPopover } from '../../components/BookingViews/components/BookingViewTabPopover';
import { ThemeIcon, Popover } from '@good/ui/core';
import { ChevronDown } from '@good/icons';
import { ICustomView } from 'interfaces/custom-views-interface';
import { CustomViewsModalType } from 'utilities/enum-utils';

interface BookingViewTabActionIconProps {
  tab: ICustomView;
  openBookingViewModal: (type: CustomViewsModalType) => void;
}

export const BookingViewTabActionIcon = ({ tab, openBookingViewModal }: BookingViewTabActionIconProps) => {
  const [showTabIconPopover, setShowTabIconPopover] = useState('');
  const togglePopOver = (value: boolean) => {
    const showTabIconPopover = value ? (tab.customViewId ?? '') : '';
    setShowTabIconPopover(showTabIconPopover);
  };
  const opened = showTabIconPopover === tab.customViewId;

  return (
    <Popover opened={opened} onChange={togglePopOver} position='bottom-start' withArrow>
      <Popover.Target>
        <ThemeIcon
          variant='default'
          size='sm'
          onClick={(e) => {
            e.stopPropagation();
            togglePopOver(!opened);
          }}
        >
          <ChevronDown />
        </ThemeIcon>
      </Popover.Target>
      <Popover.Dropdown onClick={(e) => e.stopPropagation()}>
        <BookingViewTabPopover
          onHidePopOver={togglePopOver}
          currentTab={tab}
          onShowBookingViewModal={openBookingViewModal}
        />
      </Popover.Dropdown>
    </Popover>
  );
};
